import { render, staticRenderFns } from "./addSkiiScore.vue?vue&type=template&id=75c51a23&scoped=true"
import script from "./addSkiiScore.vue?vue&type=script&lang=js"
export * from "./addSkiiScore.vue?vue&type=script&lang=js"
import style0 from "./addSkiiScore.vue?vue&type=style&index=0&id=75c51a23&prod&lang=scss&scoped=true"
import style1 from "./addSkiiScore.vue?vue&type=style&index=1&id=75c51a23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c51a23",
  null
  
)

export default component.exports